export { default } from './GlobalStyle'